import React, { useCallback, useEffect } from 'react';
import styled from '@xstyled/styled-components';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { SlideOut } from '~/ui/slide-out/SlideOut';
import { TrainingState, useTrainingStore } from '../state';
import { Header } from './Header';
import { OpenNavigationButton } from './NavButton';
import { TableOfContent } from './TableOfContent';
import { TrainingTitle } from './TrainingTitle';
import { select } from '~/lib/select';
import { useOpenCloseAudioEffect } from '~/ui/audio-effect/useOpenCloseAudioEffect';
import { useLocation } from 'react-router-dom';
import { useQueryParams } from '~/lib/useQuery';

const SlideOutContent = styled.divBox`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: auto auto 1fr;
  box-sizing: border-box;
  ol {
    li {
      ul {
        margin-right: -3px;
        li {
          a {
            padding-right: 10px;
            gap: 8px;
            margin-left: 18px;
          }
        }
      }
    }
  }
`;

SlideOutContent.defaultProps = {
  w: { _: '100vw', sm: '290px' }
};

const selector = (s: TrainingState) => select(s, 'open', 'toggleNav');

export const Navigation = () => {
  const queryParams = useQueryParams();
  const { open, toggleNav } = useTrainingStore(selector);

  const hideHomeIcon = queryParams.get('hideHomeIcon') === 'true';

  useOpenCloseAudioEffect(open);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (params.get('menu') === 'true') {
      toggleNav(true);
    }
  }, []);

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      toggleNav(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  const onFocus = () => {
    if (window.document) {
      const element = window?.document?.querySelector(
        '.autofocus'
      ) as HTMLElement;

      if (element) {
        element.focus();
      }
    }
  };

  useEffect(() => {
    if (window.document) {
      const element = window?.document?.querySelector(
        '.closeBtn'
      ) as HTMLElement;

      if (element) {
        element.focus();
      }
    }
  }, [open]);

  return (
    <>
      {queryParams.get('removeAllButtons') !== 'true' && (
        <OpenNavigationButton />
      )}
      <div autoFocus className="autofocus" onFocus={onFocus}>
        <SlideOut
          open={open}
          side="left"
          overlayClicked={() => toggleNav(false)}
        >
          <CloseButton onClick={() => toggleNav(false)} />
          <SlideOutContent className="navigationStyleForDarkTheme">
            <Header hideHomeIcon={hideHomeIcon} />
            <TrainingTitle />
            <TableOfContent />
          </SlideOutContent>
        </SlideOut>
      </div>
    </>
  );
};
